import React from 'react'
import { Modal } from '../../../components/elements'
import ImageGallery from 'react-image-gallery'
import { handleHeicImageType } from 'components/utils/handleHeicImageTypes'
import 'react-image-gallery/styles/css/image-gallery.css'
import './ImageGridModal.css'

const ImageGridModal = (props) => {
  const renderRightNav = (onClick, disabled) => {
    return (
      <RightNav
        onClick={onClick}
        disabled={disabled}
        isMobile={props.isMobile}
      />
    )
  }
  const renderLeftNav = (onClick, disabled) => {
    return (
      <LeftNav
        onClick={onClick}
        disabled={disabled}
        isMobile={props.isMobile}
      />
    )
  }
  const { reviewImages } = props
  let profileImages = []
  reviewImages.map((bikeImage) => {
    const url = handleHeicImageType(
      bikeImage?.url, bikeImage?.jpg_url,
      bikeImage.cloudinary_public_id
    )
    profileImages.push({
      original: url,
      thumbnail: url,
    })
  })
  return (
    <>
      {props.showGridModal === true && (
        <div className="grid-gallery-modal-wrapper">
          <Modal
            images={!props.isMobile}
            className="my-modal-name"
            showClose={true}
            closeOnEsc={true}
            closeOnBlur={true}
            onClose={() => {
              document.body.classList.remove('bike-profile-modal-open')
              props.toggleModal()
            }}
            show={props.showGridModal}
            size="fullscreen"
          >
            <ImageGallery
              items={profileImages}
              renderRightNav={renderRightNav}
              renderLeftNav={renderLeftNav}
            />
          </Modal>
        </div>
      )}
    </>
  )
}

const RightNav = (props) => {
  const settings = {
    width: props.isMobile ? '2rem' : '5.75rem',
    height: props.isMobile ? '2rem' : '3rem',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: props.isMobile ? '26px' : '38px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }
  const { onClick } = props
  return (
    <button
      className="bikegallery-nextarrow-wrapper image-gallery-icon image-gallery-right-nav"
      onClick={onClick}
    >
      <div classname="next-arrow">
        <i className="fas fa-angle-right" style={settings}></i>
      </div>
    </button>
  )
}

const LeftNav = (props) => {
  const settings = {
    width: props.isMobile ? '2rem' : '5.75rem',
    height: props.isMobile ? '2rem' : '3rem',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: props.isMobile ? '26px' : '38px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }
  const { onClick } = props
  return (
    <button
      className="bikegallery-leftarrow-wrapper image-gallery-icon image-gallery-left-nav"
      onClick={onClick}
    >
      <div classname="next-arrow">
        <i className="fas fa-angle-left" style={settings}></i>
      </div>
    </button>
  )
}

export default ImageGridModal

ImageGridModal.defaultProps = {
  showGridModal: false,
}
